<template>
	<div>
		<b-row class="mt-4 pr-xl-2 pl-xl-2 pb-3" no-gutters>
			<b-col xl="2" lg="4" class="d-none d-lg-block pr-2">
				<b-navbar :sticky="true" class="p-0" style="top: 100px">
					<div class="w-100 mt-2 filter-scroll" style="height: CALC(100vh - 100px); overflow-y: scroll;">
						<b-alert show variant="dark">
							<b>FILTROS</b>
						</b-alert>
						<div class="auctions-list">
							<b-alert variant="secondary" :class="{ active: auction.selected, 'shadow-sm p-0': true}" show v-for="(auction, index) in auctions" :key="index" :id="'auction-'+auction.id" :data-id="auction.id" :data-title="auction.title">
								<table @click="filterAuction(auction)" class="table m-0 table-borderless">
									<tr>
										<td style="background-color: rgba(255, 255, 255, .5);" width="10%">
											<font-awesome-layers class="fa-lg">
												<font-awesome-icon :icon="['fas', 'square']" class="text-white" />
												<font-awesome-icon :icon="['fal', 'square']" class="text-macal" v-if="auction.selected" /> 
												<font-awesome-icon :icon="['fal', 'square']" class="text-light-grey" v-else />
												<font-awesome-icon :icon="['fas', 'check']" transform="shrink-6" class="text-macal" v-if="auction.selected"  />
											</font-awesome-layers>
										</td>
										<td class="title">
											<small><b>{{auction.title}}</b></small>
										</td>
									</tr>
								</table>
							</b-alert>
						</div>
						<!-- BRAND -->
						<b-card class="mb-3 bg-white shadow-sm" border-variant="light">
							<b-card-text>
								<h6 class="mb-2"><b>Marca</b></h6>
								<multiselect v-model="car_brands" :options="car_brands_options" placeholder="Seleccionar" track-by="value" label="text" :multiple="true" :searchable="true"  @input="onSelectCarBrand" selectLabel="" deselectLabel="" selectedLabel="">
								</multiselect>
							</b-card-text>
						</b-card>
						<!-- END BRAND -->
						<!-- YEAR -->
						<b-card class="mb-3 bg-white shadow-sm" border-variant="light">
							<b-card-text>
								<h6 class="mb-2"><b>Año</b></h6>
								<div class="text-right"><small>{{year_filter[0]}} - {{year_filter[1]}}</small></div>
								<vue-slider ref="slider" v-model="year_filter" :silent="true" :enable-cross="false" :tooltip="'none'" :min="year_min" :max="year_max" :tooltip-placement="'bottom'" ></vue-slider>
							</b-card-text>
						</b-card>
						<!-- END YEAR -->
						<!-- PRICE -->
						<b-card v-if="false" class="mb-3 bg-white shadow-sm" border-variant="light">
							<b-card-text>
								<h6 class="mb-2"><b>Rango Precio Mínimo</b></h6>
								<div class="text-right"><small>{{price_filter[0] | numberFormatWithZero}} - {{price_filter[1] | numberFormatWithZero}}</small></div>
								<vue-slider ref="slider" v-model="price_filter" :silent="true" :enable-cross="false" :tooltip-formatter="formatter1" :tooltip="'none'" :min="price_min" :max="price_max" :tooltip-placement="'bottom'" :rail-style="'red'" ></vue-slider>
							</b-card-text>
						</b-card>
						<!-- END PRICE -->
						<!-- TYPE -->
						<b-card class="mb-3 bg-white shadow-sm" border-variant="light">
							<b-card-text>
								<h6 class="mb-2"><b>Modelo</b></h6>
								<multiselect v-model="car_models" :options="car_models_options" placeholder="Seleccionar" track-by="value" label="text" :multiple="true" :searchable="true"  @input="onSelectCarModel" selectLabel="" deselectLabel="" selectedLabel="">
								</multiselect>
							</b-card-text>
						</b-card>
						<!-- END TYPE -->
						<!-- TYPE -->
						<b-card v-if="false" class="mb-3 bg-white shadow-sm" border-variant="light">
							<b-card-text>
								<h6 class="mb-2"><b>Tipo de auto</b></h6>
								<multiselect v-model="car_types" :options="car_types_options" placeholder="Seleccionar" track-by="value" label="text" :multiple="true" :searchable="true"  @input="onSelectCarType" selectLabel="" deselectLabel="" selectedLabel="">
								</multiselect>
							</b-card-text>
						</b-card>
						<!-- END TYPE -->
						<!-- FUEL -->
						<b-card class="mb-3 bg-white shadow-sm" border-variant="light">
							<b-card-text>
								<h6 class="mb-2"><b>Combustible</b></h6>
								<multiselect v-model="car_fuel_types" :options="car_fuel_types_options" placeholder="Seleccionar" track-by="value" label="text" :multiple="true" :searchable="true"  @input="onSelectCarFuelType" selectLabel="" deselectLabel="" selectedLabel="">
								</multiselect>
							</b-card-text>
						</b-card>
						<!-- END FUEL -->
						<!-- TRACTION -->
						<b-card class="mb-3 bg-white shadow-sm" border-variant="light">
							<b-card-text>
								<h6 class="mb-2"><b>Tracción</b></h6>
								<multiselect v-model="car_tractions" :options="car_tractions_options" placeholder="Seleccionar" track-by="value" label="text" :multiple="true" :searchable="true"  @input="onSelectCarTraction" selectLabel="" deselectLabel="" selectedLabel="">
								</multiselect>
							</b-card-text>
						</b-card>
						<!-- END TRACTION -->
						<!-- TRANSMISSION -->
						<b-card class="mb-3 bg-white shadow-sm" border-variant="light">
							<b-card-text>
								<h6 class="mb-2"><b>Transmisión</b></h6>
								<multiselect v-model="car_transmissions" :options="car_transmissions_options" placeholder="Seleccionar" track-by="value" label="text" :multiple="true" :searchable="true"  @input="onSelectCarTransmission" selectLabel="" deselectLabel="" selectedLabel="">
								</multiselect>
							</b-card-text>
						</b-card>
						<!-- END TRANSMISSION -->
						<!-- SCORE -->
						<b-card class="mb-3 bg-white shadow-sm" border-variant="light">
							<b-card-text>
								<h6 class="mb-2"><b>Nota Macal</b>
									<font-awesome-layers v-b-tooltip.hover title="La Nota Macal es otorgada por el cálculo de +85 puntos validados por FullMec.">
										<font-awesome-icon :icon="['fas', 'circle']" />
										<font-awesome-icon :icon="['fas', 'question']" transform="shrink-6" :style="{ color: 'white' }" />
									</font-awesome-layers>
								</h6>
								<div class="text-right"><small>{{new Intl.NumberFormat("es-CL").format(score_filter[0])}} - {{new Intl.NumberFormat("es-CL").format(score_filter[1])}}</small></div>
								<vue-slider ref="slider" :interval="0.5" v-model="score_filter" :silent="true" :enable-cross="false" :tooltip="'none'" :min="score_min" :max="score_max" :tooltip-placement="'bottom'" ></vue-slider>
							</b-card-text>
						</b-card>
						<!-- END SCORE -->
					</div>
				</b-navbar>
			</b-col>
			<b-col>
				<b-navbar class="auction-data bg-grey py-2 px-0 mb-3 navbar-search" :sticky="true">
					<multiselect @remove="cleanElement" @select="addElement" v-model="value" placeholder="Buscador por tipo, marca, modelo, combustible, tracción y/o transmisión" @search-change="search_input" label="name" track-by="value" :options="options" :multiple="true" :searchable="true"  @input="scroll_top" selectLabel="Presiona enter para agregar" deselectLabel="Presiona enter para eliminar" selectedLabel="Seleccionado">
						<template slot="option" slot-scope="props">
							<span class="option__title">
								{{ props.option.name }} <b style="font-size: .7rem;">{{setProcedence(props.option.code)}}</b>
							</span>
						</template>
						<template slot="noOptions">
							No hay registros.
						</template>
						<span slot="noResult">No se encontraron resultados.</span>
					</multiselect>
				</b-navbar>
				<b-button v-b-toggle="'collapse-filters'" block variant="macal" class="d-lg-none mb-4">Ver otros Filtros</b-button>
				<b-collapse id="collapse-filters" class="d-lg-none mb-4">
					<b-card>
						<div class="auctions2-list">
							<b-alert variant="secondary" :class="{ active: auction.selected, 'shadow-sm p-0': true}" show v-for="(auction, index) in auctions" :id="'auction2-'+auction.id" :key="index" :data-id="auction.id" :data-title="auction.title">
								<table @click="filterAuction(auction)" class="table m-0 table-borderless">
									<tr>
										<td style="background-color: rgba(255, 255, 255, .5);" width="10%">
											<font-awesome-layers class="fa-lg">
												<font-awesome-icon :icon="['fas', 'square']" class="text-white" />
												<font-awesome-icon :icon="['fal', 'square']" class="text-macal" v-if="auction.selected" /> 
												<font-awesome-icon :icon="['fal', 'square']" class="text-light-grey" v-else />
												<font-awesome-icon :icon="['fas', 'check']" transform="shrink-6" class="text-macal" v-if="auction.selected"  />
											</font-awesome-layers>
										</td>
										<td class="title">
											<small><b>{{auction.title}}</b></small>
										</td>
									</tr>
								</table>
							</b-alert>
						</div>

						<!-- YEAR -->
						<b-card class="mb-3 bg-white shadow-sm" border-variant="light">
							<b-card-text>
								<h6 class="mb-2"><b>Año</b></h6>
								<div class="text-right"><small>{{year_filter[0]}} - {{year_filter[1]}}</small></div>
								<vue-slider ref="slider" v-model="year_filter" :silent="true" :enable-cross="false" :tooltip="'none'" :min="year_min" :max="year_max" :tooltip-placement="'bottom'" ></vue-slider>
							</b-card-text>
						</b-card>
						<!-- END YEAR -->
						<!-- PRICE -->
						<b-card class="mb-3 bg-white shadow-sm" border-variant="light">
							<b-card-text>
								<h6 class="mb-2"><b>Rango Precio Mínimo</b></h6>
								<div class="text-right"><small>{{price_filter[0] | numberFormatWithZero}} - {{price_filter[1] | numberFormatWithZero}}</small></div>
								<vue-slider ref="slider" v-model="price_filter" :silent="true" :enable-cross="false" :tooltip-formatter="formatter1" :tooltip="'none'" :min="price_min" :max="price_max" :tooltip-placement="'bottom'" :rail-style="'red'" ></vue-slider>
							</b-card-text>
						</b-card>
						<!-- END PRICE -->
					</b-card>
				</b-collapse>
				<div v-if="total_entries > 0 && (cars.length > 0)" class="text-right mb-1">
					Se encontraron <b>{{ total_entries }} resultados</b>
				</div>
				<div v-if="loadingCard">
					<b-card-group deck class="card-cars">
						<v-car-card-loading v-for="(loadingCard, index) in loadingCards" :key="index" ></v-car-card-loading>
					</b-card-group>
				</div>
				<div v-else>
					<b-container v-if="(cars.length == 0)" fluid>
						<b-row>
							<b-col offset-md="1" md="10" offset-lg="1" lg="10" class="mt-5 p-5 bg-dark-grey text-center shadow-sm">
								<h4>No hay resultados de búsqueda, prueba eliminando filtros.</h4>
								<h4>¿Quieres que te avisemos cuando tengamos lo que buscas?</h4>
								<b-button size="lg" class=" mt-5 pl-5 pr-5" variant="macal" href="https://www.macal.cl/Form/AvisenVehiculos">Encarga tu próximo auto aquí</b-button>
							</b-col>
						</b-row>
					</b-container>
					<b-card-group v-else="" deck class="card-cars">
						<v-car-card v-for="(car, index) in cars" :key="index" :car="car"></v-car-card>
					</b-card-group>
				</div>
				<infinite-loading @infinite="infiniteHandler" ref="infiniteLoading">
					<div slot="no-more"></div>
					<div slot="no-results"></div>
				</infinite-loading>
			</b-col>
		</b-row>
	</div>
</template>

<script>
	import CarCard from "../components/car-card";
	import CarCardLoading from "../components/car-card-loading";
	import Multiselect from 'vue-multiselect';

  export default {
	name: 'CarsList',
	components: {
		'v-car-card': CarCard,
		'v-car-card-loading': CarCardLoading,
		Multiselect,
	},
	data (){
		return {
			delete_year: false,
			delete_price: false,
			delete_score: false,
			search_brand_text: '', // If value is falsy, reset searchText & searchItem
			search_type_text: '', // If value is falsy, reset searchText & searchItem
			car_brands: [],
			car_models: [],
			car_types: [],
			car_fuel_types: [],
			car_tractions: [],
			car_transmissions: [],
			car_brands_options: [],
			car_models_options:  [],
			car_types_options:  [],
			car_fuel_types_options: [],
			car_tractions_options: [],
			car_transmissions_options: [],
			last_select_car_brand: {},
			last_select_car_model: {},
			last_select_car_type: {},
			last_select_car_fuel_type: {},
			last_select_car_traction: {},
			last_select_car_transmission: {},
			price_min: 0,
			price_max: 0,
			year_min: 0,
			year_max: 0,
			score_min: 0,
			score_max: 7.0,
			price_filter: [0,0],
			year_filter:[0,0],
			score_filter: [0,7.0],
			firstYear: true,
			firstPrice: true,
			firstScore: true,
			searchBox: null,
			options: [],
			value: [],
			sender: [],
			formatter1: v => `$${('' + v).replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`,
			macalCars: [],
			cars: [],
			auctions: [],
			loadingCards: 8,
			featured_loading_cards: 4,
			loadingCard: true,
			auction: null,
			current_page: 1,
			per_page: 0,
			total_entries: 0,
			aggregations: {},
			suggestions: [],
			page: 1,
		}
	},
	beforeMount(){
		this.setBorderRange();
	},
	mounted(){
		this.value = [];
		this.master_search();
		this.setFilterData();
	},
	methods: {
		infiniteHandler($state) {
			this.page += 1;
			this.axios.get("cars/search", {
				params: {
					options: this.sender,
					page: this.page,
				},
			}).then(result => {
				if (result.data.entries.length > 0) {
					this.total_entries = result.data.total_entries
					this.per_page = result.data.per_page
					this.current_page = result.data.current_page
					this.cars = this.cars.concat(result.data.entries.filter((car => !this.cars.some(car2 => car2.id === car.id))))
					let countList = this.cars.reduce(function(p, c){
						p[c.id] = (p[c.id] || 0) + 1;
						return p;
					}, {});
					this.cars = this.cars.filter(car => countList[car.id] == 1)
					$state.loaded();
				} else {
					$state.complete();
				}
			});
		},
		search_input(query){
			this.axios.get("cars/search_tag",  {params: {term: query}}).then(result => {
				this.options = result.data.map(res => {return { name: res.name, code: res.model_name, value: res.id };});
			}).catch(() => {
			})
		},
		scroll_top(){
			window.scroll({
				top: document.querySelector('.car-grid').offsetTop
			});
			this.master_search();
		},
		master_search(){
			this.page = 1;
			if(typeof this.$refs.infiniteLoading === "object"){ 
				this.$refs.infiniteLoading.stateChanger.reset();
			}
			this.loadingCard = true
			this.cars = []
			this.featured_cars = []
			this.map_value()
			this.axios.get("cars/search", {params: {options: this.sender, page: this.page}}).then(result => {
				this.cars = result.data.entries
				this.total_entries = result.data.total_entries
				this.per_page = result.data.per_page
				this.current_page = result.data.current_page
				this.loadingCard = false
			}).catch(() => {
				this.cars = []
				this.loadingCard = false
			})
		},
		map_value(){
			this.sender = []
			this.value.map(option => {
				this.sender.push(option)
			})
		},
		listcars(){
			const cur = this;
			this.axios.get("cars").then(result => {
				cur.cars = result.data
				this.loadingCard = false;
			})
			.catch(() => {
				cur.$store.commit('hideLoading');
			})
		},
		setFilterData(){
			const cur = this;
			this.axios.get("auctions").then(result => {
				cur.auctions = result.data;
			}).catch(() => {
				cur.$store.commit('hideLoading');
			})
			this.axios.get("cars/get_brands").then(result => {
				cur.car_brands_options = result.data;
			}).catch(() => {
				cur.$store.commit('hideLoading');
			})
			this.axios.get("cars/get_models")
			.then(result => {
				cur.car_models_options = result.data;
			})
			.catch(() => {
				cur.$store.commit('hideLoading');
			})

			this.axios.get("cars/get_car_types")
			.then(result => {
				cur.car_types_options = result.data;
			})
			.catch(() => {
				cur.$store.commit('hideLoading');
			})

			this.axios.get("cars/get_car_fuel_type")
			.then(result => {
				cur.car_fuel_types_options = result.data;
			})
			.catch(() => {
				cur.$store.commit('hideLoading');
			})

			this.axios.get("cars/get_car_traction")
			.then(result => {
				cur.car_tractions_options = result.data;
			})
			.catch(() => {
				cur.$store.commit('hideLoading');
			})

			this.axios.get("cars/get_car_transmission")
			.then(result => {
				cur.car_transmissions_options = result.data;
			})
			.catch(() => {
				cur.$store.commit('hideLoading');
			})
		},
		setBorderRange(){
			const cur = this;
			this.axios.get("cars/get_years_min_max").then(result => {
				cur.year_min = result.data.year_min;
				cur.year_max = result.data.year_max;
				cur.year_filter = [ cur.year_min , cur.year_max ];
			}).catch(() => {
              cur.$store.commit('hideLoading');
			})
			// this.axios.get("cars/get_scores").then(result => {
			// 	cur.score_min = result.data.score_min;
			// 	cur.score_max = result.data.score_max;
			// 	cur.score_filter = [ cur.score_min , cur.score_max ];
			// }).catch(error => {
            //   cur.$store.commit('hideLoading');
			// })
			this.axios.get("cars/get_prices").then(result => {
				cur.price_min = result.data.price_min;
				cur.price_max = result.data.price_max;
				cur.price_filter = [ cur.price_min , cur.price_max ];
			}).catch(() => {
              cur.$store.commit('hideLoading');
			})
		},
		formatNumber(value){
			return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
		},
		onSelectCarBrand (items, lastSelectItem) {
			const cur = this;
			this.car_brands = items
			this.last_select_car_brand = lastSelectItem
			cur.value.find((o, i) => {
				if(typeof o != 'undefined'){
					if (o.code === 'car_brand') {
						cur.value.splice(i, 1)
					}
				}
			});
		},
		onSelectCarType (items, lastSelectItem) {
			const cur = this;
			this.car_types = items
			this.last_select_car_type = lastSelectItem
			cur.value.find((o, i) => {
				if(typeof o != 'undefined'){
					if (o.code === 'car_type') {
						cur.value.splice(i, 1)
					}
				}
			});
		},
		onSelectCarModel (items, lastSelectItem) {
			const cur = this;
			this.car_models = items
			this.last_select_car_model = lastSelectItem
			cur.value.find((o, i) => {
				if(typeof o != 'undefined'){
					if (o.code === 'car_model') {
						cur.value.splice(i, 1)
					}
				}
			});
		},
		onSelectCarFuelType (items, lastSelectItem) {
			const cur = this;
			this.car_fuel_types = items
			this.last_select_car_fuel_type = lastSelectItem
			cur.value.find((o, i) => {
				if(typeof o != 'undefined'){
					if (o.code === 'car_fuel_type') {
						cur.value.splice(i, 1)
					}
				}
			});
		},
		onSelectCarTraction (items, lastSelectItem) {
			const cur = this;
			this.car_tractions = items
			this.last_select_car_traction = lastSelectItem
			cur.value.find((o, i) => {
				if(typeof o != 'undefined'){
					if (o.code === 'car_traction') {
						cur.value.splice(i, 1)
					}
				}
			});
		},
		onSelectCarTransmission (items, lastSelectItem) {
			const cur = this;
			this.car_transmissions = items
			this.last_select_car_transmission = lastSelectItem
			cur.value.find((o, i) => {
				if(typeof o != 'undefined'){
					if (o.code === 'car_transmission') {
						cur.value.splice(i, 1)
					}
				}
			});
		},
		// deselect option
		reset () {
			this.items = [] // reset
		},
		// select option from parent component
		selectFromParentComponent () {
			this.items = _.unionWith(this.items, [this.options[0]], _.isEqual)
		},
		filterAuction(auction){
			this.auctions.map(function(v) {v.selected = false });
			auction.selected = true;
			this.auction = { name: event.target.closest(".alert").dataset.title, code: "auction", value: event.target.closest(".alert").dataset.id }
		},
		cleanElement(removedOption){
			const cur = this;
			switch(removedOption.code) {
				case "car_type":
					this.car_types.map(function(v,i) {
						if(v.value == removedOption.value) {
							cur.car_types.splice(i, 1);
						}
					});
					break;
				case "car_brand":
					this.car_brands.map(function(v,i) {
						if(v.value == removedOption.value) {
							cur.car_brands.splice(i, 1);
						}
					});
					break;
				case "year":
					this.delete_year = true;
					this.year_filter = [ this.year_min , this.year_max ];
					break;
				case "price":
					this.delete_price = true;
					this.price_filter = [ this.price_min , this.price_max ];
					break;
				case "score":
					this.delete_score = true;
					this.score_filter = [ this.score_min , this.score_max ];
					break;
				case "car_model":
					this.car_models.map(function(v,i) {
						if(v.value == removedOption.value) {
							cur.car_models.splice(i, 1);
						}
					});
					break;
				case "car_fuel_type":
					this.car_fuel_types.map(function(v,i) {
						if(v.value == removedOption.value) {
							cur.car_fuel_types.splice(i, 1);
						}
					});
					break;
				case "car_traction":
					this.car_tractions.map(function(v,i) {
						if(v.value == removedOption.value) {
							cur.car_tractions.splice(i, 1);
						}
					});
					break;
				case "car_transmission":
					this.car_transmissions.map(function(v,i) {
						if(v.value == removedOption.value) {
							cur.car_transmissions.splice(i, 1);
						}
					});
					break;
				case "auction":
					if(parseInt(removedOption.value) !== 0){
						document.querySelector(".auctions-list").querySelector(".active").classList.remove("active");
						document.querySelector(".auctions2-list").querySelector(".active").classList.remove("active");
						document.getElementById("auction-0").classList.add("active");
						document.getElementById("auction2-0").classList.add("active");
						this.auctions.forEach((auction)=> {
							auction.selected = false;
						});
						this.auctions[0].selected = true;
					}
					break;
			}
		},
		addElement(addOption){
			// Add from input select to sidebar search
			switch(addOption.code) {
				case "car_type":
					this.car_types.push({
						text: addOption.name,
						value: addOption.value
					})
					break;
				case "car_brand":
					this.car_brands.push({
						text: addOption.name,
						value: addOption.value
					})
					break;
				case "car_model":
					this.car_models.push({
						text: addOption.name,
						value: addOption.value
					})
					break;
				case 'car_fuel_type':
					this.car_fuel_types.push({
						text: addOption.name,
						value: addOption.value
					})
					break;
				case 'car_traction':
					this.car_tractions.push({
						text: addOption.name,
						value: addOption.value
					})
					break;
				case 'car_transmission':
					this.car_transmissions.push({
						text: addOption.name,
						value: addOption.value
					})
					break;
			}},
		setProcedence(value){
			switch(value) {
				case "car_type":
					return "Tipo de auto";
				case "car_brand":
					return "Marca de auto";
				case "car_model":
					return "Modelo de auto";
				case "car_fuel_type":
					return "Combustible";
				case "car_traction":
					return "Tracción";
				case "car_transmission":
					return "Transmisión";
				case "dvl_storage":
					return "Patente";
			}
		}
	},
	watch: {
		year_filter: {
			handler: function() {
				/**/
				if(this.delete_year == false){
					if(this.firstYear == true){
						this.firstYear = false;
					}else{
						let hasYear = false;
						this.value.find((o) => {
							if (o.code === 'year') {
								hasYear = true;
								o.value = this.year_filter[0]+"-"+this.year_filter[1];
								o.name = "Año "+this.year_filter[0]+" - "+this.year_filter[1]
							}
						});
						if(hasYear == false){
							this.value.push({
								name: "Año "+this.year_filter[0]+" - "+this.year_filter[1],
								code: "year",
								value: this.year_filter[0]+"-"+this.year_filter[1]
							});
						}
						this.scroll_top()
					}
				}else{
					this.scroll_top()
					this.delete_year = false;
				}
				/**/
			}
		},
		score_filter: {
			handler: function() {
				/**/
				if(this.delete_score == false){
					if(this.firstScore == true){
						this.firstScore = false;
					}else{
						let hasScore = false;
						this.value.find((o) => {
							if (o.code === 'score') {
								hasScore = true;
								o.value = this.score_filter[0]+"-"+this.score_filter[1];
								o.name = "Nota "+this.score_filter[0]+" - "+this.score_filter[1]
							}
						});
						if(hasScore == false){
							this.value.push({
								name: "Nota "+this.score_filter[0]+" - "+this.score_filter[1],
								code: "score",
								value: this.score_filter[0]+"-"+this.score_filter[1]
							});
						}
						this.scroll_top()
					}
				}else{
					this.scroll_top()
					this.delete_score = false;
				}
				/**/
			}
		},
		price_filter: {
			handler: function() {
				/**/
				if(this.delete_price == false){
					if(this.firstPrice == true){
						this.firstPrice = false;
					}else{
						let hasPrice = false;
						this.value.find((o) => {
							if (o.code === 'price') {
								hasPrice = true;
								o.name = "Precio $"+this.formatNumber(this.price_filter[0])+" - $"+this.formatNumber(this.price_filter[1])
								o.value = this.price_filter[0]+"-"+this.price_filter[1]
							}
						});
						if(hasPrice == false){
							this.value.push({
								name: "Precio $"+this.formatNumber(this.price_filter[0])+" - $"+this.formatNumber(this.price_filter[1]),
								code: "price",
								value: this.price_filter[0]+"-"+this.price_filter[1]
							});
						}
						this.scroll_top()
						/**/
					}
				}else{
					this.scroll_top()
					this.delete_price = false;
				}
			}
		},
		car_types: {
			handler: function() {
				const cur = this;
				let list = [];
				this.value.find((o) => {
					if (o.code != 'car_type') {
						list.push(o)
					}
				});
				this.value = list;
				this.car_types.map(function(v) {
					cur.value.push({
						name: v.text,
						code: 'car_type',
						value: v.value
					})
				});
				this.scroll_top()
			}
		},
		car_brands: {
			handler: function() {
				const cur = this;
				let list = [];
				this.value.find((o) => {
					if (o.code != 'car_brand') {
						list.push(o)
					}
				});
				this.value = list;
				this.car_brands.map(function(v) {
					cur.value.push({
						name: v.text,
						code: 'car_brand',
						value: v.value
					})
				});
				this.scroll_top()
			}
		},
		car_models: {
			handler: function() {
				const cur = this;
				let list = [];
				this.value.find((o) => {
					if (o.code != 'car_model') {
						list.push(o)
					}
				});
				this.value = list;
				this.car_models.map(function(v) {
					cur.value.push({
						name: v.text,
						code: 'car_model',
						value: v.value
					})
				});
				this.scroll_top()
			}
		},
		car_fuel_types: {
			handler: function() {
				const cur = this;
				let list = [];
				this.value.find((o) => {
					if (o.code != 'car_fuel_type') {
						list.push(o)
					}
				});
				this.value = list;
				this.car_fuel_types.map(function(v) {
					cur.value.push({
						name: v.text,
						code: 'car_fuel_type',
						value: v.value
					})
				});
				this.scroll_top()
			}
		},
		car_tractions: {
			handler: function() {
				const cur = this;
				let list = [];
				this.value.find((o) => {
					if (o.code != 'car_traction') {
						list.push(o)
					}
				});
				this.value = list;
				this.car_tractions.map(function(v) {
					cur.value.push({
						name: v.text,
						code: 'car_traction',
						value: v.value
					})
				});
				this.scroll_top()
			}
		},
		car_transmissions: {
			handler: function() {
				const cur = this;
				let list = [];
				this.value.find((o) => {
					if (o.code != 'car_transmission') {
						list.push(o)
					}
				});
				this.value = list;
				this.car_transmissions.map(function(v) {
					cur.value.push({
						name: v.text,
						code: 'car_transmission',
						value: v.value
					})
				});
				this.scroll_top()
			}
		},
		auction: {
			handler: function() {
				this.value.find((o, i) => {
					if(typeof o != 'undefined'){
						if (o.code === 'auction') {
							this.value.splice(i, 1)
						}
					}
				});
				this.value.push(this.auction)
				this.scroll_top()
			}	
		}
	}
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
	.filter-scroll::-webkit-scrollbar { width: 0 !important }
	.filter-scroll {
		overflow: -moz-scrollbars-none;
		-ms-overflow-style: none;
	}
</style>

